import {
  UnknownFieldTypeContainer,
  UnknownFieldTypeText,
} from "styles/formStyleComponents";

const UnknownFieldTypeComponent = ({ type }) => {
  return (
    <UnknownFieldTypeContainer>
      <UnknownFieldTypeText>
        Unknown field type: {type}
      </UnknownFieldTypeText>
    </UnknownFieldTypeContainer>
  );
};

export default UnknownFieldTypeComponent;

